import { LauncherStatesData } from '../hooks/stores/launcherStatesStore';

export interface StateViewInfo {
  label: string;
  iconClassName: string;
  subIconClassName?: string;
  isPausable?: boolean;
  launcherStates: Partial<LauncherStatesData>;
  significantLauncherState: [keyof LauncherStatesData, string];
}

export const stateViewsInfo = {
  stateViewNotInstalled: {
    label: 'Not Installed',
    iconClassName: 'icon-not-installed',
    launcherStates: {
      isAppInstalled: false,
    },
    significantLauncherState: ['isAppInstalled', 'false'],
  } as StateViewInfo,

  stateViewInstallationInProgress: {
    label: 'Installation',
    iconClassName: 'icon-installing',
    subIconClassName: 'icon-inprogress',
    launcherStates: {
      isAnyTaskInProgress: true,
      isInstallTaskInProgress: true,
    },
    significantLauncherState: ['isInstallTaskInProgress', 'true'],
  } as StateViewInfo,
  stateViewInstallationPaused: {
    label: 'Installation Paused',
    iconClassName: 'icon-installing',
    subIconClassName: 'icon-paused',
    launcherStates: {
      isAnyTaskPaused: true,
      isInstallTaskPaused: true,
    },
    significantLauncherState: ['isInstallTaskPaused', 'true'],
  } as StateViewInfo,
  stateViewInstallationFailed: {
    label: 'Installation Failed',
    iconClassName: 'icon-installing',
    subIconClassName: 'icon-failed',
    launcherStates: {
      hasAnyTaskFailed: true,
      hasInstallTaskFailed: true,
    },
    significantLauncherState: ['hasInstallTaskFailed', 'true'],
  } as StateViewInfo,
  stateViewUninstallationInProgress: {
    label: 'Uninstallation',
    iconClassName: 'icon-uninstall',
    subIconClassName: 'icon-inprogress',
    isPausable: false,
    launcherStates: {
      isAppInstalled: true,
      isAnyTaskInProgress: true,
      isUninstallTaskInProgress: true,
    },
    significantLauncherState: ['isUninstallTaskInProgress', 'true'],
  } as StateViewInfo,
  stateViewUninstallationFailed: {
    label: 'Uninstallation Failed',
    iconClassName: 'icon-uninstall',
    subIconClassName: 'icon-failed',
    launcherStates: {
      isAppInstalled: true,
      hasAnyTaskFailed: true,
      hasUninstallTaskFailed: true,
    },
    significantLauncherState: ['hasUninstallTaskFailed', 'true'],
  } as StateViewInfo,

  stateViewInstalled: {
    label: 'Installed',
    iconClassName: 'icon-installed',
    launcherStates: {
      isAppInstalled: true,
    },
    significantLauncherState: ['isAppInstalled', 'true'],
  } as StateViewInfo,

  stateViewRunning: {
    label: 'Running',
    iconClassName: 'icon-running',
    launcherStates: {
      isAppInstalled: true,
      isAppRunning: true,
    },
    significantLauncherState: ['isAppRunning', 'true'],
  } as StateViewInfo,
  stateViewUpdateAvailable: {
    label: 'Update Available',
    iconClassName: 'icon-update',
    launcherStates: {
      isAppInstalled: true,
      isAppUpdateAvailable: true,
    },
    significantLauncherState: ['isAppUpdateAvailable', 'true'],
  } as StateViewInfo,
  stateViewNeedRepair: {
    label: 'Need Repair',
    iconClassName: 'icon-repair',
    launcherStates: {
      isAppInstalled: true,
      doesAppNeedRepair: true,
    },
    significantLauncherState: ['doesAppNeedRepair', 'true'],
  } as StateViewInfo,
  stateViewMoveInProgress: {
    label: 'Moving',
    iconClassName: 'icon-move',
    subIconClassName: 'icon-inprogress',
    isPausable: false,
    launcherStates: {
      isAppInstalled: true,
      isAnyTaskInProgress: true,
      isMoveTaskInProgress: true,
    },
    significantLauncherState: ['isMoveTaskInProgress', 'true'],
  } as StateViewInfo,
  stateViewMoveFailed: {
    label: 'Moving Failed',
    iconClassName: 'icon-move',
    subIconClassName: 'icon-failed',
    launcherStates: {
      isAppInstalled: true,
      hasAnyTaskFailed: true,
      hasMoveTaskFailed: true,
    },
    significantLauncherState: ['hasMoveTaskFailed', 'true'],
  } as StateViewInfo,

  stateViewUpdateInProgress: {
    label: 'Updating',
    iconClassName: 'icon-update',
    subIconClassName: 'icon-inprogress',
    launcherStates: {
      isAppInstalled: true,
      isAppUpdateAvailable: true,
      isAnyTaskInProgress: true,
      isUpdateTaskInProgress: true,
    },
    significantLauncherState: ['isUpdateTaskInProgress', 'true'],
  } as StateViewInfo,
  stateViewUpdatePaused: {
    label: 'Updating Paused',
    iconClassName: 'icon-update',
    subIconClassName: 'icon-paused',
    launcherStates: {
      isAppInstalled: true,
      isAppUpdateAvailable: true,
      isAnyTaskPaused: true,
      isUpdateTaskPaused: true,
    },
    significantLauncherState: ['isUpdateTaskPaused', 'true'],
  } as StateViewInfo,
  stateViewUpdateFailed: {
    label: 'Updating Failed',
    iconClassName: 'icon-update',
    subIconClassName: 'icon-failed',
    launcherStates: {
      isAppInstalled: true,
      isAppUpdateAvailable: true,
      hasAnyTaskFailed: true,
      hasUpdateTaskFailed: true,
    },
    significantLauncherState: ['hasUpdateTaskFailed', 'true'],
  } as StateViewInfo,
  stateViewRepairInProgress: {
    label: 'Repairing',
    iconClassName: 'icon-repair',
    subIconClassName: 'icon-inprogress',
    launcherStates: {
      isAppInstalled: true,
      doesAppNeedRepair: true,
      isAnyTaskInProgress: true,
      isRepairTaskInProgress: true,
    },
    significantLauncherState: ['isRepairTaskInProgress', 'true'],
  } as StateViewInfo,
  stateViewRepairPaused: {
    label: 'Repairing Paused',
    iconClassName: 'icon-repair',
    subIconClassName: 'icon-paused',
    launcherStates: {
      isAppInstalled: true,
      doesAppNeedRepair: true,
      isAnyTaskPaused: true,
      isRepairTaskPaused: true,
    },
    significantLauncherState: ['isRepairTaskPaused', 'true'],
  } as StateViewInfo,
  stateViewRepairFailed: {
    label: 'Repairing Failed',
    iconClassName: 'icon-repair',
    subIconClassName: 'icon-failed',
    launcherStates: {
      isAppInstalled: true,
      doesAppNeedRepair: true,
      hasAnyTaskFailed: true,
      hasRepairTaskFailed: true,
    },
    significantLauncherState: ['hasRepairTaskFailed', 'true'],
  } as StateViewInfo,
};
